import React, { Component } from "react";
import { Switch } from "react-router-dom";

import PrivateRoute from "../../utils/PrivateRoute";
import PageNotFound from "../shared/components/notices/PageNotFound";

import InvoiceUpload from "./containers/InvoiceUpload";
import InvoiceDetails from "./containers/InvoiceDetails";
import InvoiceContactForm from "./containers/InvoiceContactForm";

class InvoiceRoutes extends Component {
  render() {
    return (
      <Switch>
        <PrivateRoute
          exact
          path="/invoices/:id/new"
          component={InvoiceUpload}
        />
        <PrivateRoute
          exact
          path="/invoices/:id/add_contact"
          component={InvoiceContactForm}
        />
        <PrivateRoute
          exact
          path="/invoices/new"
          component={InvoiceUpload}
        />
        <PrivateRoute
          exact
          path="/invoices/:id"
          component={InvoiceDetails}
        />
        <PrivateRoute component={PageNotFound} />
      </Switch>
    );
  }
}

export default InvoiceRoutes;



// WEBPACK FOOTER //
// ./src/features/trade_documents/invoiceRoutes.js